import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const containerStyle = css`
  border-radius: ${theme.borderRadius.medium};
  box-shadow: ${theme.shadows.light};
  cursor: pointer;
  padding-bottom: ${theme.spacing(2)};

  &:hover {
    box-shadow: ${theme.shadows.floating};
  }
`;
